import { getSlackAuthUrl, SLACK_APP_SETTINGS_URL } from '~/logic/slack';
import { popupWindow } from '~/logic/url/popup';
import { api } from '~/trpc-extra/api';

export const useSlack = () => {
  const getSlackJWT = api.project.getJWT.useMutation();

  const connectSlack = async (projectId: string, testSuiteId?: string) => {
    const slackCSRFToken = await getSlackJWT.mutateAsync({
      projectId,
      typeKey: 'slack',
      metadata: { testSuiteId },
    });
    popupWindow(
      getSlackAuthUrl({ projectId, state: slackCSRFToken, origin: window.location.origin }),
      'Connect Slack',
      window,
      500,
      700,
    );
  };

  const manageSlack = async () => {
    popupWindow(SLACK_APP_SETTINGS_URL, 'Manage Slack', window, 500, 700);
  };

  return { connectSlack, manageSlack };
};
